"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.responseSchema = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    dateFrom: zod_1.z.string().datetime(),
    dateTo: zod_1.z.string().datetime(),
    propertyId: zod_1.z.number(),
    timezone: zod_1.z.string(),
});
exports.responseSchema = zod_1.z.array(zod_1.z.object({
    propertyId: zod_1.z.number(),
    blocks: zod_1.z.array(zod_1.z.object({
        blockId: zod_1.z.number(),
        sprays: zod_1.z.object({
            timeseries: zod_1.z.array(zod_1.z.object({
                timestamp: zod_1.z.string().datetime(),
                products: zod_1.z.array(zod_1.z.object({
                    name: zod_1.z.string(),
                    rate: zod_1.z.string(),
                })),
            })),
        }),
    })),
}));
exports.path = '/spray-records';
//# sourceMappingURL=index.js.map